import { render, staticRenderFns } from "./MonthlySalaryCreate.vue?vue&type=template&id=e761120e&"
import script from "./MonthlySalaryCreate.vue?vue&type=script&lang=js&"
export * from "./MonthlySalaryCreate.vue?vue&type=script&lang=js&"
import style0 from "./MonthlySalaryCreate.vue?vue&type=style&index=0&id=e761120e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports